import React from 'react';
import history from 'pages/router/history';

const withRouteAwareIframe = BaseComponent =>
  class WithRouteAwareIframe extends React.Component {
    constructor(props) {
      super(props);
      this.setRef = this.setRef.bind(this);
    }

    componentDidMount() {
      this.iframeEl = this.el.getElementsByTagName('iframe')[0];
      this.unlisten = history.listen((location, action) => {
        this.onRouteChange(action, location.pathname);
      });
    }

    componentWillUnmount() {
      this.unlisten();
    }

    onRouteChange(action, pathname) {
      const message = {
        type: 'setRoute',
        payload: { action, pathname },
      };
      this.iframeEl.contentWindow.postMessage(message, '*');
    }

    setRef(el) {
      this.el = el;
    }

    render() {
      return (
        <div ref={this.setRef} style={{ width: '100%', height: '100%' }}>
          <BaseComponent {...this.props} />
        </div>
      );
    }
  };

export default withRouteAwareIframe;
